<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="短剧名称" prop="videoId" >
        <!--        <a-input v-model="form.videoId" placeholder="请输入短剧id" />-->
        <a-select
          v-model="form.videoId"
          showSearch
          style="width: 100%"
          placeholder="请选择短剧"
          allow-clear
          optionFilterProp="children"
        >
          <a-select-option :value="item.id" :key="item.id" :title="item.videoName" v-for="(item,index) in listAll">
            {{item.videoName}}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="当前集数" prop="serialNumber" >
        <a-input-number :min="1" v-model="form.serialNumber" placeholder="请输入当前集数" />
      </a-form-model-item>
<!--      <a-form-model-item label="购买类型" prop="type" >-->
<!--&lt;!&ndash;        <a-input v-model="form.type" placeholder="请输入是否可以使用金币购买 0-否 1-是" />&ndash;&gt;-->

<!--        <a-select placeholder="请选择购买类型" v-model="form.type">-->
<!--          <a-select-option :key="0">免费</a-select-option>-->
<!--          <a-select-option :key="1">金币</a-select-option>-->
<!--          <a-select-option :key="2">金币</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->

<!--      <a-form-model-item label="短剧时长" prop="duration" >-->
<!--        <a-input v-model="form.duration" placeholder="请输入短剧时长" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="视频" prop="videoUrl" >
<!--        <a-input v-model="form.videoUrl" placeholder="请输入短剧url" />-->
        <a-upload
          listType="picture-card"
          class="avatar-uploader video-uploader"
          v-model="form.videoUrl"
          :showUploadList="false"
          :beforeUpload="beforeUploadVideo"
          :customRequest="handleChange"
        >
          <video :src="form.videoUrl" v-if="form.videoUrl" width="300" height="150" controls></video>

<!--          <img v-if="form.videoUrl" :src="form.videoUrl" alt="logo"-->
<!--               style="height:104px;max-width:300px"/>-->
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>

            <div class="ant-upload-text">上传</div>
          </div>
<!--          <a-spin v-if="uploadLoading" />-->
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="法语字幕" prop="subtitleCn">
        <a-upload
          :showUploadList="false"
          :beforeUpload="beforeUploadCn"
          :customRequest="handleChangeCn"
        >
          <a-button type="primary" :loading="uploadLoadingCn" v-if="this.form.subtitleCn">更换</a-button>
          <a-button :loading="uploadLoadingCn" v-else> <a-icon type="upload" /> 上传 </a-button>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="阿拉伯字幕" prop="subtitle">
        <a-upload
          :showUploadList="false"
          :beforeUpload="beforeUploadZh"
          :customRequest="handleChangeZh"
        >
          <a-button type="primary" :loading="uploadLoadingZh" v-if="this.form.subtitle">更换</a-button>
          <a-button :loading="uploadLoadingZh" v-else> <a-icon type="upload" /> 上传 </a-button>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="英文字幕" prop="subtitleEn">
        <a-upload
          :showUploadList="false"
          :beforeUpload="beforeUploadEn"
          :customRequest="handleChangeEn"
        >
          <a-button type="primary" :loading="uploadLoadingEn" v-if="form.subtitleEn">更换</a-button>
          <a-button :loading="uploadLoadingEn" v-else> <a-icon type="upload" /> 上传 </a-button>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="西班牙语字幕" prop="subtitleBm">
        <a-upload
          :showUploadList="false"
          :beforeUpload="beforeUploadBm"
          :customRequest="handleChangeBm"
        >
          <a-button type="primary" :loading="uploadLoadingBm" v-if="form.subtitleBm">更换</a-button>
          <a-button :loading="uploadLoadingBm" v-else> <a-icon type="upload" /> 上传 </a-button>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item label="日语字幕" prop="subtitleIn">
        <a-upload
          :showUploadList="false"
          :beforeUpload="beforeUploadIn"
          :customRequest="handleChangeIn"
        >
          <a-button type="primary" :loading="uploadLoadingIn" v-if="form.subtitleIn">更换</a-button>
          <a-button :loading="uploadLoadingIn" v-else> <a-icon type="upload" /> 上传 </a-button>
        </a-upload>
      </a-form-model-item>
      <!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getGather, addGather, updateGather } from '@/api/video/gather'
import { listVideo } from '@/api/video/video'
import TagSelectOption from "@/components/TagSelect/TagSelectOption";
import { uploadToCos } from '@/utils/upload-to-cos'
import { uploadOss, ensureHttpsUrl } from '@/api/tool/oss'
import { getSTSToken } from '@/api/tool/common'
import COS from 'cos-js-sdk-v5'
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    TagSelectOption
  },
  data () {
    return {
      listAll:[],
      submitLoading: false,
      formTitle: '',
      progress: 0,
      uploadLoading:false,
      uploadLoadingCn: false,
      uploadLoadingZh: false,
      uploadLoadingEn: false,
      uploadLoadingBm: false,
      uploadLoadingIn: false,
      // 表单参数
      form: {
        id: null,

        type: null,

        duration: null,

        videoUrl: null,

        videoId: null,

        serialNumber: null,

        createTime: null,

        remark: null,
        subtitleCn: null,
        subtitle: null,
        subtitleEn: null,
        subtitleBm: null,
        subtitleIn: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      fileList:[],
      fileListEn:[],
      rules: {
        type: [
          { required: true, message: '购买类型不能为空' }
        ],
        duration: [
          { required: true, message: '短剧时长不能为空' }
        ],
        videoUrl: [
          { required: true, message: '视频不能为空' }
        ],
        videoId: [
          { required: true, message: '短剧名称不能为空' }
        ],
        serialNumber: [
          { required: true, message: '当前集数不能为空' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getGather();
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    beforeUploadVideo:function (file) {
      debugger
      var fileType = file.type;
      if (fileType.indexOf('video') < 0) {
        this.$message.warning('请上传视频');
        this.form.videoUrl = '';
        return false
      }

      //TODO 驗證文件大小
    },
    beforeUploadCn: function (file) {
      var fileType = file.name;
      if (fileType.indexOf('vtt') < 0 && fileType.indexOf('srt') < 0) {
        this.$message.warning('请上传vtt或srt文件');
        this.uploadLoadingCn = false;
        return false;
      }
      this.form.subtitleCn = '';
      this.uploadLoadingCn = true;
      // 返回 false 阻止默认上传，强制使用 customRequest
      return false;
    },
    beforeUploadZh: function (file) {
      var fileType = file.name;
      if (fileType.indexOf('vtt') < 0 && fileType.indexOf('srt') < 0) {
        this.$message.warning('请上传vtt或srt文件');
        this.uploadLoadingZh = false;
        return false;
      }
      this.form.subtitle = '';
      this.uploadLoadingZh = true;
      // 返回 false 阻止默认上传，强制使用 customRequest
      return false;
    },
    beforeUploadEn: function (file) {
      var fileType = file.name;
      if (fileType.indexOf('vtt') < 0 && fileType.indexOf('srt') < 0) {
        this.$message.warning('请上传vtt或srt文件');
        this.uploadLoadingEn = false;
        return false;
      }
      this.form.subtitleEn = '';
      this.uploadLoadingEn = true;
      // 返回 false 阻止默认上传，强制使用 customRequest
      return false;
    },
    beforeUploadBm: function (file) {
      var fileType = file.name;
      if (fileType.indexOf('vtt') < 0 && fileType.indexOf('srt') < 0) {
        this.$message.warning('请上传vtt或srt文件');
        this.uploadLoadingBm = false;
        return false;
      }
      this.form.subtitleBm = '';
      this.uploadLoadingBm = true;
      // 返回 false 阻止默认上传，强制使用 customRequest
      return false;
    },
    beforeUploadIn: function (file) {
      var fileType = file.name;
      if (fileType.indexOf('vtt') < 0 && fileType.indexOf('srt') < 0) {
        this.$message.warning('请上传vtt或srt文件');
        this.uploadLoadingIn = false;
        return false;
      }
      this.form.subtitleIn = '';
      this.uploadLoadingIn = true;
      // 返回 false 阻止默认上传，强制使用 customRequest
      return false;
    },
    /**
     * 字幕文件上传方法
     * 使用 /common/oss 接口获取临时凭证，然后直接上传到腾讯云COS
     * @param {Object} info - 上传文件信息对象
     * @param {String} prefix - 文件路径前缀，如 'subtitle/cn', 'subtitle/zh' 等
     * @param {String} fieldName - form表单字段名
     * @param {String} loadingField - loading状态字段名
     */
    async uploadSubtitleToCos(info, prefix, fieldName, loadingField) {
      console.log('uploadSubtitleToCos 开始执行，使用 /common/oss 接口')
      const that = this
      that[loadingField] = true
      try {
        // 1. 生成文件路径
        const filePath = uploadOss(info.file.name, prefix)
        console.log('生成的文件路径:', filePath)

        // 2. 使用 getAuthorization 回调方式，动态获取临时凭证
        // getSTSToken() 内部调用 /common/oss 接口（POST方法）
        const cos = new COS({
          getAuthorization: async function(options, callback) {
            try {
              console.log('调用 getSTSToken() 获取临时凭证（/common/oss 接口）')
              const stsToken = await getSTSToken() // 调用 /common/oss 接口
              console.log('获取到的临时凭证:', stsToken)
              if (!stsToken || !stsToken.data) {
                callback('获取COS凭证失败')
                return
              }

              const startTime = Math.floor(Date.now() / 1000)
              const expiredTime = startTime + 1800

              callback({
                TmpSecretId: stsToken.data.accessKeyId,
                TmpSecretKey: stsToken.data.accessKeySecret,
                XCosSecurityToken: stsToken.data.securityToken,
                ExpiredTime: expiredTime,
                StartTime: startTime
              })
            } catch (error) {
              callback(error.message || '获取COS凭证失败')
            }
          },
          Protocol: 'https:',
          Timeout: 60000,
          UseAccelerate: false,
          CorrectClockSkew: true
        })

        // 3. 获取 bucket 和 region 信息
        const stsToken = await getSTSToken()
        if (!stsToken || !stsToken.data) {
          throw new Error('获取COS凭证失败')
        }

        const bucket = stsToken.data.bucket
        const region = stsToken.data.region

        // 4. 判断文件大小，选择上传方式
        const fileSize = info.file.size
        const isLargeFile = fileSize > 5 * 1024 * 1024 // 5MB

        let uploadResult
        if (isLargeFile) {
          uploadResult = await cos.uploadFile({
            Bucket: bucket,
            Region: region,
            Key: filePath,
            Body: info.file,
            SliceSize: 1024 * 1024 * 5,
            ContentType: info.file.type || 'application/octet-stream'
          })
        } else {
          uploadResult = await cos.putObject({
            Bucket: bucket,
            Region: region,
            Key: filePath,
            Body: info.file,
            ContentType: info.file.type || 'application/octet-stream'
          })
        }

        // 5. 检查上传结果并构建 URL
        if (uploadResult && (uploadResult.statusCode === 200 || uploadResult.ETag || uploadResult.Location)) {
          let url = ''
          if (stsToken.data.staticUrl) {
            url = stsToken.data.staticUrl + (stsToken.data.staticUrl.endsWith('/') ? '' : '/') + filePath
          } else if (uploadResult.Location) {
            url = uploadResult.Location
          } else {
            url = `https://${bucket}.cos.${region}.myqcloud.com/${filePath}`
          }
          // 确保 URL 包含 https:// 前缀
          url = ensureHttpsUrl(url)

          that.form[fieldName] = url
          that[loadingField] = false
          if (info.onSuccess) {
            info.onSuccess({ url }, info.file)
          }
        } else {
          throw new Error('上传失败，返回结果异常')
        }
      } catch (error) {
        that[loadingField] = false
        that.$message.error(error.message || '上传失败，请重试')
        if (info.onError) {
          info.onError(error)
        }
      }
    },
    async handleChangeCn(info) {
      console.log('handleChangeCn 被调用，使用 /common/oss 接口上传')
      await this.uploadSubtitleToCos(info, 'subtitle/cn', 'subtitleCn', 'uploadLoadingCn')
    },
    async handleChangeZh(info) {
      console.log('handleChangeZh 被调用，使用 /common/oss 接口上传')
      await this.uploadSubtitleToCos(info, 'subtitle/zh', 'subtitle', 'uploadLoadingZh')
    },
    async handleChangeEn(info) {
      console.log('handleChangeEn 被调用，使用 /common/oss 接口上传')
      await this.uploadSubtitleToCos(info, 'subtitle/en', 'subtitleEn', 'uploadLoadingEn')
    },
    async handleChangeBm(info) {
      console.log('handleChangeBm 被调用，使用 /common/oss 接口上传')
      await this.uploadSubtitleToCos(info, 'subtitle/bm', 'subtitleBm', 'uploadLoadingBm')
    },
    async handleChangeIn(info) {
      console.log('handleChangeIn 被调用，使用 /common/oss 接口上传')
      await this.uploadSubtitleToCos(info, 'subtitle/in', 'subtitleIn', 'uploadLoadingIn')
    },
    async handleChange(options) {
      const { file } = options
      this.uploadLoading = true
      this.form.videoUrl = ""

      try {
        const url = await uploadToCos(
          file,
          'video',
          (progress) => {
            // 进度回调
            if (options.onProgress) {
              options.onProgress(progress)
            }
          }
        )
        this.form.videoUrl = url
        this.uploadLoading = false
        if (options.onSuccess) {
          options.onSuccess({ url }, file)
        }
      } catch (error) {
        this.uploadLoading = false
        this.$message.error(error.message || '上传失败')
        if (options.onError) {
          options.onError(error)
        }
      }
    },
    handleUpload(info) { //上传主图(一张图)
      console.log(info)
      let that = this;
      this.form.videoUrl = "";
      this.uploadLoading = true;
      // ossUpload(info.file)
      //  , function (fileName) {
      //   console.log('--------------------------------')
      //   console.log(fileName)
      //   console.log('--------------------------------')
      //   that.uploadLoading = false;
      //   that.form.coverUrl = fileName;
      // }
    },
    getGather() {
      listVideo().then(res => {
        this.listAll = res.data;
      })
    },
    onClose () {
      this.open = false
      this.uploadLoading = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        isGoldBuy: null,
        duration: null,
        videoUrl: null,
        videoId: null,
        serialNumber: null,
        createTime: null,
        remark: null,
        subtitleCn: null,
        subtitle: null,
        subtitleEn: null,
        subtitleBm: null,
        subtitleIn: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : (Array.isArray(ids) ? ids[0] : ids)
      getGather({"id":id}).then(response => {
        this.form = response.data;
        if(response.data.subtitleCn) {
          this.fileList=[{
            uid: '-1',
            name: '文件',
            status: 'done',
            url: response.data.subtitleCn,
          }]
        } else {
          this.fileList=[]
        }

        if(response.data.subtitleEn) {
          this.fileListEn=[{
            uid: '1',
            name: '文件',
            status: 'done',
            url: response.data.subtitleEn,
          }]
        } else {
          this.fileListEn=[]
        }

        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateGather(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addGather(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
